import type { IIconProps } from '@/components/Atoms/Icon/Icon';
import { Icon, IconSize } from '@/components/Atoms/Icon/Icon';
import classNames from '@/utils/classNames';
import type { AnchorHTMLAttributes } from 'react';
import type { FCl } from 'react-fc';
import styles from './IconLink.module.css';

export const IconLink: FCl<IProps> = ({ className, icon, text, ...rest }) => (
    <a className={classNames(styles.styledLink, className)} {...rest}>
        <Icon size={IconSize.TEXT} use={icon} />
        <span>{text}</span>
    </a>
);

interface IProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
    icon: IIconProps['use'];
    text: string;
}
